import React from 'react';
import { BookOpen, Target, GraduationCap, Zap } from 'lucide-react';
import { Button } from '../ui/button';

const ACTIONS = [
  {
    id: 'study-plan',
    icon: BookOpen,
    title: 'Study Plan',
    description: 'Generate personalized plan',
    bg: 'bg-blue-500/20',
    iconColor: 'text-blue-400',
    testId: 'generate-study-plan',
  },
  {
    id: 'quick-quiz',
    icon: Target,
    title: 'Quick Quiz',
    description: 'Test your knowledge',
    bg: 'bg-purple-500/20',
    iconColor: 'text-purple-400',
    testId: 'generate-quiz',
  },
  {
    id: 'exam-prep',
    icon: GraduationCap,
    title: 'Exam Prep',
    description: 'Strategy & tips',
    bg: 'bg-green-500/20',
    iconColor: 'text-green-400',
    testId: 'generate-exam-strategy',
  },
  {
    id: 'explain',
    icon: Zap,
    title: 'Explain',
    description: 'Clarify concepts',
    bg: 'bg-orange-500/20',
    iconColor: 'text-orange-400',
    testId: 'explain-concepts',
  },
];

export const QuickActions = ({
  onStudyPlan, onQuiz, onExamStrategy, onExplain, loading,
}) => {
  const handlers = {
    'study-plan': onStudyPlan,
    'quick-quiz': onQuiz,
    'exam-prep': onExamStrategy,
    'explain': onExplain,
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {ACTIONS.map(({ id, icon: Icon, title, description, bg, iconColor, testId }) => (
        <Button
          key={id}
          variant="outline"
          className="p-4 h-auto flex-col items-start text-left rounded-xl border-[var(--isp-glass-border)] hover:bg-[var(--isp-glass-inner)] hover:border-purple-500/30"
          onClick={handlers[id]}
          disabled={loading}
          data-testid={testId}
        >
          <div className="flex items-center gap-2 mb-2 w-full">
            <div className={`w-10 h-10 rounded-lg ${bg} flex items-center justify-center`}>
              <Icon className={`w-5 h-5 ${iconColor}`} />
            </div>
            <h3 className="font-medium text-white text-sm">{title}</h3>
          </div>
          <p className="text-xs text-[var(--isp-body)]">{description}</p>
        </Button>
      ))}
    </div>
  );
};
